import { useEffect, useRef } from "react";
import { CALENDLY_URL } from "@/constants/calendly";

const SCRIPT_SRC = "https://assets.calendly.com/assets/external/widget.js";

export default function CalendlyInline() {
  const hostRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    const init = () => {
      if (!cancelled && window.Calendly && hostRef.current) {
        hostRef.current.replaceChildren();
        window.Calendly.initInlineWidget({
          url: CALENDLY_URL,
          parentElement: hostRef.current,
          resize: true,
        });
      }
    };

    const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", init, { once: true });
      init();
    } else {
      const script = document.createElement("script");
      script.src = SCRIPT_SRC;
      script.async = true;
      script.onload = init;
      document.body.appendChild(script);
    }

    return () => {
      cancelled = true;
      if (hostRef.current) hostRef.current.replaceChildren();
    };
  }, []);

  return (
    <div
      ref={hostRef}
      data-testid="calendly-inline-widget"
      className="w-full overflow-hidden border border-gold/40 bg-ivory"
      style={{ minWidth: 320, minHeight: 700 }}
      aria-label="Schedule a consultation"
    />
  );
}
